import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMsal } from '@azure/msal-react';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import { Divider, Stack, Typography } from '@mui/material';

import useUser from '@api/auth/useUser';
import { Avatar, Menu } from '@components/base';

const UserInfobox: FC = () => {
  const { t } = useTranslation();
  const { instance, accounts } = useMsal();
  const { firstName, lastName, name, email, roles } = useUser();
  const initials = `${firstName.at(0) ?? ''}${lastName.at(0) ?? ''}`;

  const handleSignOut = () =>
    instance.logoutRedirect({ account: instance.getActiveAccount() ?? accounts[0] });

  return (
    <Menu>
      <Menu.IconButton aria-label={name} sx={{ p: 0 }}>
        <Avatar color='secondary'>{initials}</Avatar>
      </Menu.IconButton>

      <Menu.Content sx={{ '& .MuiPaper-root': { minWidth: 280, maxWidth: 380 } }}>
        <Stack alignItems='center' direction='row' px={2} py={1.5} spacing={1.5}>
          <Avatar color='secondary' size='large' sx={{ flexShrink: 0 }}>
            {initials}
          </Avatar>

          <Stack spacing={0.25} sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
            <Typography component='span' fontWeight={600} variant='subtitle1'>
              {name}
            </Typography>

            <Typography color='text.secondary' variant='body2'>
              {email}
            </Typography>

            {roles.length > 0 && (
              <Typography color='text.secondary' variant='caption'>
                {t('roles')}: {roles.join(', ')}
              </Typography>
            )}
          </Stack>
        </Stack>

        <Divider />

        <Menu.Item
          icon={<LogoutRounded fontSize='small' />}
          onClick={handleSignOut}
          sx={{
            mx: 0.75,
            my: 0.5,
            px: 1.5,
            py: 1,
            borderRadius: 1,
            '& .MuiListItemIcon-root': { minWidth: 32, color: 'text.secondary' },
          }}
        >
          {t('signOut')}
        </Menu.Item>
      </Menu.Content>
    </Menu>
  );
};
export default UserInfobox;
